<style lang="sass" scoped>
.form-group.required .control-label:after {
  content: '*';
  color: red;
}
</style>

<template>
  <modal v-ref:modal :is-shown.sync="isShown" size="lg">
    <div slot="content" id="customer-create-form" v-show="isShown">
      <div class="modal-header">
        <span>お客様新規登録</span>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div v-if="errorResponse" class="alert alert-danger" role="alert">
          <ul>
            <li v-for="e in nonFieldErrors">{{ e }}</li>
            <li v-for="errors in fieldErrors" v-if="errors.length">
              {{ formLabels[$key] }}
              <ul>
                <li v-for="e in errors">{{ e }}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group form-group-sm required" v-bind:class="{'has-error': fieldErrors.account.length}">
              <label class="control-label" for="customer-id-{{ _uid }}">{{ formLabels['account'] }}</label>
              <div class="form-inline">
                <span>{{ shop.name }}({{ shop.code }})&nbsp;</span>
                <input id="customer-id-{{ _uid }}" type="text" class="form-control" v-model="convertedAccount">
              </div>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.phoneNumber.length}">
              <label class="control-label" for="phone-number-{{ _uid }}">{{ formLabels['phoneNumber'] }}</label>
              <input id="phone-number-{{ _uid }}" type="text" class="form-control" v-model="phoneNumber">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group form-group-sm required" v-bind:class="{'has-error': fieldErrors.familyNameKana.length || fieldErrors.firstNameKana.length}">
              <label class="control-label">{{ formLabels['nameKana'] }}</label>
              <div class="form-inline">
                <input type="text" class="form-control" v-model="familyNameKana" placeholder="{{ formLabels['familyNameKana'] }}">
                <input type="text" class="form-control" v-model="firstNameKana" placeholder="{{ formLabels['firstNameKana'] }}">
              </div>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.familyName.length || fieldErrors.firstName.length}">
              <label class="control-label">{{ formLabels['name'] }}</label>
              <div class="form-inline">
                <input type="text" class="form-control" v-model="familyName" placeholder="{{ formLabels['familyName'] }}">
                <input type="text" class="form-control" v-model="firstName" placeholder="{{ formLabels['firstName'] }}">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.email.length}">
              <label class="control-label" for="customer-id-{{ _uid }}">{{ formLabels['email'] }}</label>
              <input id="customer-id-{{ _uid }}" type="text" class="form-control" v-model="email">
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.age.length}">
              <label class="control-label">{{ formLabels['age'] }}</label>
              <select id="age-{{ _uid }}" class="form-control" v-model="age">
                <option v-for="obj in ages" value="{{ obj.value }}">{{ obj.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.gender.length}">
              <label class="control-label">{{ formLabels['gender'] }}</label>
              <div class="form-inline">
                <input type="radio" v-model="gender" value="男性" id="genderMale">
                <label for="genderMale">男性</label>
                <input type="radio" v-model="gender" value="女性" id="genderFemale">
                <label for="genderFemale">女性</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <hr>
            <h4>住所情報</h4>
            <hr>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.prefecture.length}">
              <label class="control-label">{{ formLabels['prefecture'] }}</label>
              <select id="prefecture-{{ _uid }}" class="form-control" v-model="prefecture">
                <option v-for="obj in prefectures" value="{{ obj.value }}">{{ obj.name }}</option>
              </select>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.city.length}">
              <label class="control-label">{{ formLabels['city'] }}</label>
              <input id="city-{{ _uid }}" type="text" class="form-control" placeholder="{{ formLabels['city'] }}" v-model="city">
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.address.length}">
              <label class="control-label">{{ formLabels['address'] }}</label>
              <input id="address-{{ _uid }}" type="text" class="form-control" placeholder="{{ formLabels['address'] }}" v-model="address">
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.building.length}">
              <label class="control-label">{{ formLabels['building'] }}</label>
              <input id="building-{{ _uid }}" type="text" class="form-control" placeholder="{{ formLabels['building'] }}" v-model="building">
            </div>
          </div>
          <div class="col-sm-6">
            <hr>
            <h4>fufuを知ったきっかけ</h4>
            <hr>
            <template v-for="tmp in knownReasonChoices">
              <input type="checkbox" :id="tmp.pk" :value="tmp.pk" v-model="knownReasons">
              <label :for="tmp.pk" style="margin-right: 20px;">{{ tmp.name }}</label>
              <br v-if="($index + 1 ) % 3 === 0">
            </template>
            <br>
            <input type="text" v-model="knownReasonOther" placeholder="その他">
            <hr>
            <h4>来店のきっかけ</h4>
            <hr>
            <template v-for="tmp in visitReasonChoices">
              <input type="checkbox" :id="tmp.pk" :value="tmp.pk" v-model="visitReasons">
              <label :for="tmp.pk" style="margin-right: 20px;">{{ tmp.name }}</label>
              <br v-if="($index + 1 ) % 3 === 0">
            </template>
            <br>
            <input type="text" v-model="visitReasonOther" placeholder="その他">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger pull-left" @click="reset">リセット</button>
        <button class="btn btn-primary" :disabled="isSending" @click="submit()">登録</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'customer-create-form',
  props: {
    shop: {
      type: Object,
      required: true,
    },
  },
  data () {
    let data = this.defaultData()
    let ages = [
      {value: '', name: '年代'},
      {value: '10歳未満', name: '10歳未満'},
      {value: '10代', name: '10代'},
      {value: '20代', name: '20代'},
      {value: '30代', name: '30代'},
      {value: '40代', name: '40代'},
      {value: '50代', name: '50代'},
      {value: '60代', name: '60代'},
      {value: '70代', name: '70代'},
      {value: '80代', name: '80代'},
      {value: '90代', name: '90代'},
    ]
    let prefectures = [
      {value: '', name: '都道府県'},
      {value: '北海道', name: '北海道'},
      {value: '青森県', name: '青森県'},
      {value: '岩手県', name: '岩手県'},
      {value: '宮城県', name: '宮城県'},
      {value: '秋田県', name: '秋田県'},
      {value: '山形県', name: '山形県'},
      {value: '福島県', name: '福島県'},
      {value: '茨城県', name: '茨城県'},
      {value: '栃木県', name: '栃木県'},
      {value: '群馬県', name: '群馬県'},
      {value: '埼玉県', name: '埼玉県'},
      {value: '千葉県', name: '千葉県'},
      {value: '東京都', name: '東京都'},
      {value: '神奈川県', name: '神奈川県'},
      {value: '新潟県', name: '新潟県'},
      {value: '富山県', name: '富山県'},
      {value: '石川県', name: '石川県'},
      {value: '福井県', name: '福井県'},
      {value: '山梨県', name: '山梨県'},
      {value: '長野県', name: '長野県'},
      {value: '岐阜県', name: '岐阜県'},
      {value: '静岡県', name: '静岡県'},
      {value: '愛知県', name: '愛知県'},
      {value: '三重県', name: '三重県'},
      {value: '滋賀県', name: '滋賀県'},
      {value: '京都府', name: '京都府'},
      {value: '大阪府', name: '大阪府'},
      {value: '兵庫県', name: '兵庫県'},
      {value: '奈良県', name: '奈良県'},
      {value: '和歌山県', name: '和歌山県'},
      {value: '鳥取県', name: '鳥取県'},
      {value: '島根県', name: '島根県'},
      {value: '岡山県', name: '岡山県'},
      {value: '広島県', name: '広島県'},
      {value: '山口県', name: '山口県'},
      {value: '徳島県', name: '徳島県'},
      {value: '香川県', name: '香川県'},
      {value: '愛媛県', name: '愛媛県'},
      {value: '高知県', name: '高知県'},
      {value: '福岡県', name: '福岡県'},
      {value: '佐賀県', name: '佐賀県'},
      {value: '長崎県', name: '長崎県'},
      {value: '熊本県', name: '熊本県'},
      {value: '大分県', name: '大分県'},
      {value: '宮崎県', name: '宮崎県'},
      {value: '鹿児島県', name: '鹿児島県'},
      {value: '沖縄県', name: '沖縄県'},
      {value: 'その他', name: 'その他'},
    ]
    Object.assign(data, {
      isShown: false,
      isSending: false,
      ages: ages,
      prefectures: prefectures,
      visitReasonChoices: [],
      knownReasonChoices: [],
    })
    return data
  },
  computed: {
    nonFieldErrors() {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors() {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}

      Object.assign(errors, {
        note: e.note ? e.note : [],

        account: e && e.account ? e.account : [],
        phoneNumber: e && e.phoneNumber ? e.phoneNumber : [],
        familyNameKana: e && e.familyNameKana ? e.familyNameKana : [],
        firstNameKana: e && e.firstNameKana ? e.firstNameKana : [],
        familyName: e && e.familyName ? e.familyName : [],
        firstName: e && e.firstName ? e.firstName : [],
        email: e && e.email ? e.email : [],
        age: e && e.age ? e.age : [],
        gender: e && e.gender ? e.gender : [],
        prefecture: e && e.prefecture_id ? e.prefecture_id : [],
        city: e && e.city ? e.city : [],
        address: e && e.address ? e.address : [],
        building: e && e.building ? e.building : [],
        knownReasons: e && e.knownReasons ? e.knownReasons : [],
        visitReasons: e && e.visitReasons ? e.visitReasons : [],
      })
      return errors
    },
    convertedAccount: {
      get() {
        return this.account
      },
      set(val) {
        if (val) {
          this.account = val.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
          })
        } else {
          this.account = ''
        }
      }
    },
  },
  methods: {
    show() {
      this.isShown = true;
    },
    reset() {
      let data = this.defaultData()
      Object.keys(data).forEach(k => this[k] = data[k])
    },
    close() {
      this.isShown = false;
    },
    defaultData() {
      return {
        errorResponse: null,
        account: null,
        email: '',
        phoneNumber: '',
        familyNameKana: '',
        firstNameKana: '',
        familyName: '',
        firstName: '',
        customerNote: '',
        age: '',
        gender: '',
        prefecture: '',
        city: '',
        address: '',
        building: '',
        visitReasons: [],
        visitReasonOther: '',
        knownReasons: [],
        knownReasonOther: '',
        formLabels: {
          account: 'お客様番号',
          phoneNumber: '電話番号',
          nameKana: '氏名(カナ)',
          familyNameKana: '姓(カナ)',
          firstNameKana: '名(カナ)',
          age: '年代',
          gender: '性別',
          name: '氏名',
          familyName: '姓',
          firstName: '名',
          email: 'メールアドレス',
          prefecture: '都道府県',
          city: '市区町村郡',
          address: '町名番地',
          building: 'ビル名等',
          knownReasons: 'fufuを知ったきっかけ',
          visitReasons: '来店のきっかけ',
        },
      }
    },
    constructCustomer () {
      return {
        shop: this.shop.pk,
        account: this.account,
        phoneNumber: this.phoneNumber,
        email: this.email,
        familyNameKana: this.familyNameKana,
        firstNameKana: this.firstNameKana,
        familyName: this.familyName,
        firstName: this.firstName,
        gender: this.gender,
        note: this.customerNote,
        age: this.age,
        prefecture: this.prefecture,
        city: this.city,
        address: this.address,
        building: this.building,
        visitReasons: this.visitReasons,
        visitReasonOther: this.visitReasonOther,
        knownReasons: this.knownReasons,
        knownReasonOther: this.knownReasonOther,
      }
    },
    submit() {
      if (!this.account) {
        return new Promise((resolve, reject) => {
          if (!this.errorResponse) {
            this.errorResponse = {body: {}}
          }
          this.errorResponse.body.account = ['お客様番号を入力してください']
          return;
        })
      }
      this.isSending = true
      let customer = this.constructCustomer()
      return this.apiPost(
          '/api/1.0/customers/',
          customer,
          {shopAs: this.shop.pk}
      ).then(response => {
        alert('登録しました')
        this.reset()
        this.close()
      }).catch(reason => {
        console.log(reason)
        if (reason.error.status == 400) {
          this.errorResponse = reason.response
        }
        return Promise.reject(reason)
      }).finally(() => {
        this.isSending = false
      })
    },
  },
  mixins: [
    require('mixin/wait.vue'),
    require('mixin/api-client.vue'),
  ],
  components: {
    modal: require('ui/modal.vue'),
  },
  created () {
    this.apiGet(
      '/api/1.0/customers/known-reasons/',
      null,
      {shopAs: this.shop.pk}
    ).then(response => {
      this.knownReasonChoices = response.body.results
    })
    this.apiGet(
      '/api/1.0/customers/visit-reasons/',
      null,
      {shopAs: this.shop.pk}
    ).then(response => {
      this.visitReasonChoices = response.body.results
    })
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?27d70fb6